export default __webpack_public_path__ + "static/resume-62488613f91f6439cab5227578d93db6.pdf";